import { ComponentStore } from './component-store'
import { DataCheckerService } from './data-checker.service'
import { Toaster } from './toaster.service'
import { FileUploaderFactoryService } from './file-uploader-factory.service'
import { DialogService } from './drawer-dialog.service'
import { BackendTranslationService } from './backend-translation.service'

export * from './component-store'
export * from './data-checker.service'
export * from './http-get-cache.service'
export * from './toaster.service'
export * from './file-uploader-factory.service'
export * from './drawer-dialog.service'
export * from './backend-translation.service'

// HttpGetRequestCacheService is intentionally absent: it declares providedIn: 'root' so that
// every consumer shares one cache and one in-flight request map. Listing it here would give
// each lazy-loaded module its own instance again.
export const services = [FileUploaderFactoryService, ComponentStore, DataCheckerService, Toaster, DialogService]
